import { truncateRichContent } from "@wix/ricos";
import { useState } from "react";
function useTruncateRicosContent(content, maxShownParagraphs) {
  const [isTruncated, setIsTruncated] = useState(true);
  function toggleTruncate() {
    setIsTruncated((prevState) => !prevState);
  }
  return {
    displayedContent: maxShownParagraphs && isTruncated ? truncateRichContent(content, {
      nodeCount: maxShownParagraphs
    }) : content,
    isTruncated: maxShownParagraphs ? isTruncated : false,
    isTruncateButtonShown: maxShownParagraphs ? content.nodes.length > maxShownParagraphs : false,
    toggleTruncate
  };
}
export {
  useTruncateRicosContent
};
//# sourceMappingURL=use-truncate-ricos-content.js.map
